import "./App.css";
import { useMemo } from "react";

import Minter from "./Minter";

import * as anchor from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  getPhantomWallet,
  getSolflareWallet,
  getSolletWallet,
  getMathWallet,
} from "@solana/wallet-adapter-wallets";

import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";

import { WalletDialogProvider } from "@solana/wallet-adapter-material-ui";
import { ThemeProvider, createTheme } from "@material-ui/core";

const theme = createTheme({
  palette: {
    type: "dark",
  },
});

const candyMachineId = process.env.REACT_APP_CANDY_MACHINE_ID
  ? new anchor.web3.PublicKey(process.env.REACT_APP_CANDY_MACHINE_ID)
  : undefined;

const network = process.env.REACT_APP_SOLANA_NETWORK as WalletAdapterNetwork;

const rpcHost = process.env.REACT_APP_SOLANA_RPC_HOST!;
const connection = new anchor.web3.Connection(rpcHost);

const startDateSeed = parseInt(process.env.REACT_APP_CANDY_START_DATE!, 10);

const txTimeout = 30000; // milliseconds (confirm this works for your project)

const App = () => {
  const endpoint = useMemo(() => clusterApiUrl(network), []);

  const wallets = useMemo(
    () => [
      getPhantomWallet(),
      getSolflareWallet(),
      getSolletWallet(),
      getMathWallet(),
    ],
    []
  );

  function toggleMenu() {
    const menu = document.getElementById("mobileNavContainer")!;
    menu.classList.toggle("open-menu");
    console.log("pressed");
  }

  return (
    <div>
      <div id="mobileNavContainer" className="mobile-nav">
        <div className="mobile-nav-close-button">
          <img src="/icons/close.svg" alt="" onClick={toggleMenu} />
        </div>
        <ul>
          <li>
            <a href="https://www.recordlabeldao.com"> 
              <img className="mobile-nav-logo" src="/img/Logo.jpg" alt="" />
            </a>
          </li>
          <li>
            <div className="social-icons">
              <a href="https://twitter.com/RecordLabelDAO" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-twitter"></i>
              </a>
              <a href="http://discord.gg/eQTDfJyXfZ" target="_blank" rel="noreferrer">
                <i className="fa-brands fa-discord"></i>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="mobile-menu-button" onClick={toggleMenu}>
        <img src="/icons/menu.svg" alt="" />
      </div>
      <nav>
        <div className="nav-container">
          <a href="https://www.recordlabeldao.com"> 
            <img className="nav-logo" src="/img/Logo.jpg" alt="" />
          </a>
          <div className="social-icons hide-800">
            <a href="https://twitter.com/RecordLabelDAO" target="_blank" rel="noreferrer">
              <i className="fa-brands fa-twitter"></i>
            </a>
            <a href="http://discord.gg/eQTDfJyXfZ" target="_blank" rel="noreferrer">
              <i className="fa-brands fa-discord"></i>
            </a>
          </div>
        </div>
      </nav>
      <div className="content-wrapper">
        <header className="card" id="link1">
          <div style={{ padding: "0 24px 0 24px 0" }}>
            <h3 className="text-secondary-color">Welcome To</h3>
            <h1 className="pb-3 custom-font">Record Label DAO</h1>
            <p className="text-secondary-color">
            Record Label DAO is an artist launchpad backed by a decentralized record label that offers Initial Release Offering (IRO) to the public.
            We want to offer the opportunity to invest in music & help artists launch their music career through web3 and traditional media.
            To make this happen, we're releasing our first set of 250 NFTs to fund the project.
            </p>
          </div>
          <div>
            <ThemeProvider theme={theme}>
              <ConnectionProvider endpoint={endpoint}>
                <WalletProvider wallets={wallets} autoConnect>
                  <WalletDialogProvider>
                    <Minter
                      candyMachineId={candyMachineId}
                      connection={connection}
                      startDate={startDateSeed}
                      txTimeout={txTimeout}
                      rpcHost={rpcHost}
                    />
                  </WalletDialogProvider>
                </WalletProvider>
              </ConnectionProvider>
            </ThemeProvider>
          </div>
        </header>
      </div>
      <div className="footer">
        <footer>
          <p>Created with <i className="fa-solid fa-cannabis weed"></i> by</p>
          <a href="https://twitter.com/igottheherb" className="custom-font-link" target="_blank" rel="noreferrer">Helpful Herb</a>
        </footer>
      </div>
    </div>
  );
};

export default App;
